"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrossIcon = void 0;
var CrossIcon = function () {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    var svgNS = svg.namespaceURI;
    var path = document.createElementNS(svgNS, 'path');
    svg.setAttribute('width', '8');
    svg.setAttribute('height', '8');
    svg.setAttribute('viewBox', '0 0 8 8');
    svg.setAttribute('fill', 'none');
    path.setAttribute('fill-rule', 'evenodd');
    path.setAttribute('clip-rule', 'evenodd');
    path.setAttribute('d', 'M8 0.8L7.2 0L4 3.2L0.8 0L0 0.8L3.2 4L0 7.2L0.8 8L4 4.8L7.2 8L8 7.2L4.8 4L8 0.8Z');
    path.setAttribute('fill', '#050038');
    svg.appendChild(path);
    return svg;
};
exports.CrossIcon = CrossIcon;
